import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MessageSquare, ChevronDown, Send, CheckCircle, AlertCircle, Clock, Loader } from 'lucide-react';
interface AgentsProps {
  userRole: 'Program Manager' | 'Founder';
}
const Agents: React.FC<AgentsProps> = ({
  userRole
}) => {
  const [isRunning, setIsRunning] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const [showInsights, setShowInsights] = useState(false);
  const [publishSuccess, setPublishSuccess] = useState(false);
  const handleRunAgent = () => {
    setIsRunning(true);
    setTimeout(() => {
      setIsRunning(false);
      setIsCompleted(true);
      setShowInsights(true);
    }, 3000);
  };
  const handlePublishTop3 = () => {
    setPublishSuccess(true);
    setTimeout(() => {
      setPublishSuccess(false);
    }, 3000);
  };
  return <div className="flex h-full" data-id="element-94">
      {/* Conversation List */}
      <div className="w-64 border-r border-gray-200 h-full overflow-auto" data-id="element-95">
        <div className="p-4 border-b border-gray-200" data-id="element-96">
          <h2 className="text-lg font-medium text-gray-800" data-id="element-97">Recent Agents</h2>
        </div>
        <div className="p-2" data-id="element-98">
          <div className="p-3 bg-blue-50 border border-blue-200 rounded-md mb-2" data-id="element-99">
            <div className="flex items-center mb-1" data-id="element-100">
              <MessageSquare size={16} className="text-blue-600 mr-2" data-id="element-101" />
              <span className="text-sm font-medium text-gray-800" data-id="element-102">
                Transcript Analyst
              </span>
            </div>
            <p className="text-xs text-gray-600" data-id="element-103">CardioSense</p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-104">Just now</p>
          </div>
          <div className="p-3 hover:bg-gray-50 border border-transparent rounded-md mb-2 cursor-pointer" data-id="element-105">
            <div className="flex items-center mb-1" data-id="element-106">
              <MessageSquare size={16} className="text-gray-500 mr-2" data-id="element-107" />
              <span className="text-sm font-medium text-gray-800" data-id="element-108">
                Elevator Pitch Coach
              </span>
            </div>
            <p className="text-xs text-gray-600" data-id="element-109">CardioSense</p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-110">Yesterday</p>
          </div>
          <div className="p-3 hover:bg-gray-50 border border-transparent rounded-md cursor-pointer" data-id="element-111">
            <div className="flex items-center mb-1" data-id="element-112">
              <MessageSquare size={16} className="text-gray-500 mr-2" data-id="element-113" />
              <span className="text-sm font-medium text-gray-800" data-id="element-114">
                Stakeholder Mapping
              </span>
            </div>
            <p className="text-xs text-gray-600" data-id="element-115">MedBridge AI</p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-116">2 days ago</p>
          </div>
        </div>
      </div>
      {/* Chat Thread */}
      <div className="flex-1 flex flex-col h-full" data-id="element-117">
        <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-118">
          <div data-id="element-119">
            <h2 className="text-lg font-medium text-gray-800" data-id="element-120">
              Transcript Analyst
            </h2>
            <p className="text-sm text-gray-600" data-id="element-121">CardioSense</p>
          </div>
          <div className="px-3 py-1 bg-blue-100 text-blue-800 text-xs rounded-full" data-id="element-122">
            Est. 60 credits
          </div>
        </div>
        <div className="flex-1 overflow-auto p-4" data-id="element-123">
          {/* Banner */}
          <div className="bg-green-50 border border-green-200 rounded-md p-3 mb-4 flex items-start" data-id="element-124">
            <AlertCircle size={16} className="text-green-600 mr-2 mt-0.5" data-id="element-125" />
            <div data-id="element-126">
              <p className="text-sm text-green-800 font-medium" data-id="element-127">
                Data Secured
              </p>
              <p className="text-xs text-green-700" data-id="element-128">Upload any data, it never leaves Kalphai.</p>
            </div>
          </div>
          {/* User Message */}
          <div className="flex mb-4" data-id="element-129">
            <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 mr-3" data-id="element-130">
              {userRole === 'Program Manager' ? 'AR' : 'JC'}
            </div>
            <div className="bg-white border border-gray-200 rounded-lg p-3 max-w-3xl" data-id="element-131">
              <p className="text-gray-800" data-id="element-132">
                Run Transcript Analyst on CRN-001. Focus on adherence barriers.
                Publish top 3 if confident.
              </p>
              <div className="mt-2 flex items-center" data-id="element-133">
                <div size={14} className="text-gray-500 mr-1" data-id="element-134" />
                <span className="text-xs text-gray-600" data-id="element-135">
                  CRN-001 Nurse Manager Interview (2025-09-22)
                </span>
              </div>
            </div>
          </div>
          {/* Agent Response */}
          {(isRunning || isCompleted) && <div className="flex mb-4" data-id="element-136">
              <div className="w-8 h-8 rounded-full bg-purple-100 flex items-center justify-center text-purple-600 mr-3" data-id="element-137">
                TA
              </div>
              <div className="bg-white border border-gray-200 rounded-lg p-4 max-w-3xl w-full" data-id="element-138">
                <div className="flex justify-between items-center mb-3" data-id="element-139">
                  <h3 className="font-medium text-gray-800" data-id="element-140">
                    Transcript Analyst
                  </h3>
                  <div className="flex items-center" data-id="element-141">
                    {isRunning && <span className="text-xs py-1 px-2 bg-blue-100 text-blue-800 rounded-full flex items-center" data-id="element-142">
                        <Loader size={10} className="animate-spin mr-1" data-id="element-143" />{' '}
                        Running
                      </span>}
                    {isCompleted && <span className="text-xs py-1 px-2 bg-green-100 text-green-800 rounded-full flex items-center" data-id="element-144">
                        <CheckCircle size={10} className="mr-1" data-id="element-145" /> Completed
                      </span>}
                  </div>
                </div>
                {isRunning && <div data-id="element-146">
                    <p className="text-sm text-gray-600 mb-3" data-id="element-147">
                      Analyzing transcript CRN-001...
                    </p>
                    <div className="w-full h-2 bg-gray-100 rounded-full" data-id="element-148">
                      <div className="h-2 bg-blue-500 rounded-full animate-[progress_3s_ease-in-out]" style={{
                  width: '60%'
                }} data-id="element-149"></div>
                    </div>
                  </div>}
                {isCompleted && <div data-id="element-150">
                    <div className="mb-4" data-id="element-151">
                      <h4 className="text-sm font-medium text-gray-700 mb-2" data-id="element-152">
                        Executive Summary
                      </h4>
                      <p className="text-sm text-gray-600" data-id="element-153">
                        Adherence drop-offs concentrate in weeks 2–3 due to
                        transportation, work schedules, and co-pay sensitivity.
                        Human calls outperform automated texts by ~15 percentage
                        points; digital literacy limits portal-based reminders.
                        Clear cadence education and prioritized outreach could
                        reduce no-shows; anonymized benchmarking is acceptable.
                      </p>
                    </div>
                    {showInsights && <div data-id="element-154">
                        <h4 className="text-sm font-medium text-gray-700 mb-2" data-id="element-155">
                          Insights
                        </h4>
                        {/* Insight Card 1 */}
                        <div className="border border-gray-200 rounded-md p-3 mb-3" data-id="element-156">
                          <div className="flex justify-between items-start mb-1" data-id="element-157">
                            <h5 className="font-medium text-gray-800" data-id="element-158">
                              Transportation barriers drive week 2–3 no-shows;
                              ride prompts could trigger early intervention.
                            </h5>
                            <span className="text-xs py-0.5 px-2 bg-green-100 text-green-800 rounded-full" data-id="element-159">
                              High
                            </span>
                          </div>
                          <div className="bg-gray-50 p-2 rounded text-xs text-gray-600 mb-2" data-id="element-160">
                            <span className="font-medium" data-id="element-161">Citation:</span>{' '}
                            "Transportation is number one… Weeks two and three
                            are where no-shows spike."
                          </div>
                          <div className="flex space-x-2" data-id="element-162">
                            <button className="text-xs px-2 py-1 border border-blue-200 text-blue-600 rounded hover:bg-blue-50 transition-colors" data-id="element-163">
                              Publish to Insights
                            </button>
                            <button className="text-xs px-2 py-1 border border-gray-200 text-gray-600 rounded hover:bg-gray-50 transition-colors" data-id="element-164">
                              Contribute anonymized
                            </button>
                            <button className="text-xs px-2 py-1 border border-gray-200 text-gray-600 rounded hover:bg-gray-50 transition-colors" data-id="element-165">
                              Edit
                            </button>
                          </div>
                        </div>
                        {/* Insight Card 2 */}
                        <div className="border border-gray-200 rounded-md p-3 mb-3" data-id="element-166">
                          <div className="flex justify-between items-start mb-1" data-id="element-167">
                            <h5 className="font-medium text-gray-800" data-id="element-168">
                              Human phone calls the day before and morning-of
                              reduce no-shows by ~15 points compared to
                              automated texts.
                            </h5>
                            <span className="text-xs py-0.5 px-2 bg-green-100 text-green-800 rounded-full" data-id="element-169">
                              High
                            </span>
                          </div>
                          <div className="bg-gray-50 p-2 rounded text-xs text-gray-600 mb-2" data-id="element-170">
                            <span className="font-medium" data-id="element-171">Citation:</span> "If
                            we call… we cut no-shows by around 15 percentage
                            points."
                          </div>
                          <div className="flex space-x-2" data-id="element-172">
                            <button className="text-xs px-2 py-1 border border-blue-200 text-blue-600 rounded hover:bg-blue-50 transition-colors" data-id="element-173">
                              Publish to Insights
                            </button>
                            <button className="text-xs px-2 py-1 border border-gray-200 text-gray-600 rounded hover:bg-gray-50 transition-colors" data-id="element-174">
                              Contribute anonymized
                            </button>
                            <button className="text-xs px-2 py-1 border border-gray-200 text-gray-600 rounded hover:bg-gray-50 transition-colors" data-id="element-175">
                              Edit
                            </button>
                          </div>
                        </div>
                        {/* Insight Card 3 */}
                        <div className="border border-gray-200 rounded-md p-3 mb-3" data-id="element-176">
                          <div className="flex justify-between items-start mb-1" data-id="element-177">
                            <h5 className="font-medium text-gray-800" data-id="element-178">
                              Patients misinterpret session cadence as optional;
                              reinforce insurance-authorized plan at discharge
                              and week one.
                            </h5>
                            <span className="text-xs py-0.5 px-2 bg-yellow-100 text-yellow-800 rounded-full" data-id="element-179">
                              Medium
                            </span>
                          </div>
                          <div className="bg-gray-50 p-2 rounded text-xs text-gray-600 mb-2" data-id="element-180">
                            <span className="font-medium" data-id="element-181">Citation:</span>{' '}
                            "Patients hear 'as needed'… Some think the first
                            session was a check-in and the rest are optional."
                          </div>
                          <div className="flex space-x-2" data-id="element-182">
                            <button className="text-xs px-2 py-1 border border-blue-200 text-blue-600 rounded hover:bg-blue-50 transition-colors" data-id="element-183">
                              Publish to Insights
                            </button>
                            <button className="text-xs px-2 py-1 border border-gray-200 text-gray-600 rounded hover:bg-gray-50 transition-colors" data-id="element-184">
                              Contribute anonymized
                            </button>
                            <button className="text-xs px-2 py-1 border border-gray-200 text-gray-600 rounded hover:bg-gray-50 transition-colors" data-id="element-185">
                              Edit
                            </button>
                          </div>
                        </div>
                        <div className="flex space-x-3 mt-4" data-id="element-186">
                          <button onClick={handlePublishTop3} className="px-3 py-1.5 text-sm bg-blue-600 hover:bg-blue-700 text-white rounded-md transition-colors" data-id="element-187">
                            Publish top 3
                          </button>
                          <button className="px-3 py-1.5 text-sm bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-md transition-colors" data-id="element-188">
                            Create summary note
                          </button>
                          <button className="px-3 py-1.5 text-sm bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-md transition-colors" data-id="element-189">
                            Retry with tweak
                          </button>
                        </div>
                      </div>}
                  </div>}
              </div>
            </div>}
          {/* Publish Success Message */}
          {publishSuccess && <div className="bg-green-100 border border-green-200 text-green-800 px-4 py-3 rounded-lg shadow-md flex items-center mb-4" data-id="element-190">
              <CheckCircle size={16} className="mr-2" data-id="element-191" />
              <span data-id="element-192">
                Top 3 insights published to CardioSense venture and contributed
                anonymized to Data Vault.
              </span>
              <Link to="/ventures/cardiosense" className="ml-3 text-sm text-blue-600 hover:underline" data-id="element-193">
                View in Venture
              </Link>
            </div>}
        </div>
        {/* Composer */}
        <div className="p-4 border-t border-gray-200" data-id="element-194">
          <div className="flex items-center mb-2" data-id="element-195">
            <button className="px-3 py-1 text-xs bg-blue-50 text-blue-700 rounded-full mr-2" data-id="element-196">
              Run Transcript Analyst
            </button>
            <button className="px-3 py-1 text-xs bg-gray-100 text-gray-700 rounded-full mr-2" data-id="element-197">
              Summarize interview
            </button>
            <button className="px-3 py-1 text-xs bg-gray-100 text-gray-700 rounded-full" data-id="element-198">
              Draft insights
            </button>
          </div>
          <div className="flex" data-id="element-199">
            <div className="flex-1 relative" data-id="element-200">
              <input type="text" placeholder="Ask an agent or attach an artifact…" className="w-full pl-4 pr-10 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-201" />
              <button className="absolute right-3 top-3 text-gray-400 hover:text-gray-600" data-id="element-202">
                <div size={18} data-id="element-203" />
              </button>
            </div>
            <div className="flex ml-2" data-id="element-204">
              <button className="px-3 flex items-center border border-gray-300 rounded-md mr-2 hover:bg-gray-50" data-id="element-205">
                <span className="text-sm text-gray-700 mr-1" data-id="element-206">Private</span>
                <ChevronDown size={14} className="text-gray-500" data-id="element-207" />
              </button>
              <button onClick={handleRunAgent} className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md flex items-center transition-colors" data-id="element-208">
                Run <Send size={14} className="ml-1" data-id="element-209" />
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Context Panel */}
      <div className="w-72 border-l border-gray-200 h-full overflow-auto" data-id="element-210">
        <div className="p-4 border-b border-gray-200" data-id="element-211">
          <h2 className="text-lg font-medium text-gray-800" data-id="element-212">Context</h2>
        </div>
        <div className="p-4" data-id="element-213">
          <h3 className="text-sm font-medium text-gray-700 mb-2" data-id="element-214">Artifacts</h3>
          <div className="p-3 border border-gray-200 rounded-md mb-4" data-id="element-215">
            <div className="flex items-center" data-id="element-216">
              <div size={14} className="text-gray-500 mr-2" data-id="element-217" />
              <span className="text-sm text-gray-800" data-id="element-218">
                CRN-001 Nurse Manager Interview
              </span>
            </div>
            <p className="text-xs text-gray-500 mt-1" data-id="element-219">2025-09-22</p>
            <div className="flex mt-2" data-id="element-220">
              <span className="text-xs px-2 py-0.5 bg-gray-100 text-gray-700 rounded-full mr-1" data-id="element-221">
                Stakeholder: Nurse Manager
              </span>
              <span className="text-xs px-2 py-0.5 bg-gray-100 text-gray-700 rounded-full" data-id="element-222">
                Clinical: Cardiology
              </span>
            </div>
          </div>
          <h3 className="text-sm font-medium text-gray-700 mb-2" data-id="element-223">
            Venture Profile
          </h3>
          <div className="p-3 border border-gray-200 rounded-md mb-4" data-id="element-224">
            <h4 className="text-sm font-medium text-gray-800" data-id="element-225">CardioSense</h4>
            <p className="text-xs text-gray-600 mt-1" data-id="element-226">
              Post-discharge cardiac rehab adherence drops in weeks 2–3, hurting
              outcomes and reimbursement.
            </p>
            <div className="mt-2" data-id="element-227">
              <div className="flex justify-between text-xs mb-1" data-id="element-228">
                <span className="text-gray-600" data-id="element-229">Stage:</span>
                <span className="text-gray-800" data-id="element-230">Discovery</span>
              </div>
              <div className="flex justify-between text-xs" data-id="element-231">
                <span className="text-gray-600" data-id="element-232">Credits:</span>
                <span className="text-gray-800" data-id="element-233">180 / 300</span>
              </div>
            </div>
          </div>
          <h3 className="text-sm font-medium text-gray-700 mb-2" data-id="element-234">Filters</h3>
          <div className="p-3 border border-gray-200 rounded-md" data-id="element-235">
            <div className="flex justify-between text-xs mb-2" data-id="element-236">
              <span className="text-gray-600" data-id="element-237">Agent:</span>
              <span className="text-gray-800" data-id="element-238">Transcript Analyst</span>
            </div>
            <div className="flex justify-between text-xs mb-2" data-id="element-239">
              <span className="text-gray-600" data-id="element-240">Focus:</span>
              <span className="text-gray-800" data-id="element-241">Adherence barriers</span>
            </div>
            <div className="flex justify-between text-xs" data-id="element-242">
              <span className="text-gray-600" data-id="element-243">Sensitivity:</span>
              <span className="text-gray-800" data-id="element-244">Private</span>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default Agents;